// extracted by mini-css-extract-plugin
export var content = "about-module--content--xsj40";
export var root = "about-module--root--HhfNY";